import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import TransfersPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/TransfersPage";
import Classes, { Account } from "model";
import { useEffect } from "react";

export default function CaptureLoanTransferToDD(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const account = Account.getDefaultBrandedAccountByType("checking");
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "transfer", "from" ], account)
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI(undefined, context))
    .update([ "to", "isActive" ], true)
    .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <TransfersPage data={ data } ui={ ui } />
}